import { render, staticRenderFns } from "./new excuses.vue?vue&type=template&id=298c4505"
import script from "./new excuses.vue?vue&type=script&lang=js"
export * from "./new excuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports